import { render, staticRenderFns } from "./g-header.vue?vue&type=template&id=afb77306&scoped=true"
import script from "./g-header.vue?vue&type=script&lang=ts"
export * from "./g-header.vue?vue&type=script&lang=ts"
import style0 from "./g-header.vue?vue&type=style&index=0&id=afb77306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb77306",
  null
  
)

export default component.exports